import React from "react";

const FeelingProud = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="611.461"
      height="391.60699"
      viewBox="0 0 611.461 391.60699"
      role="img"
      artist="Katerina Limpitsouni"
      source="https://undraw.co/"
    >
      <g id="f1503154-f50a-4680-8aa4-587be41cac87" data-name="Group 2">
        <rect
          id="e1abf0e4-070b-4c82-8a12-ebedd4e3db02"
          data-name="Rectangle 1"
          x="0.26201"
          y="0.347"
          width="611.461"
          height="391.60699"
          fill="#e6e6e6"
        />
        <rect
          id="ace8bea0-82e8-49b8-a50c-1e1cb532084f"
          data-name="Rectangle 2"
          x="19.746"
          y="49.464"
          width="576.492"
          height="319.32199"
          fill="#fff"
        />
        <rect
          id="b540f353-e277-4512-bc56-a133cea2858b"
          data-name="Rectangle 3"
          width="611.461"
          height="25.977"
          fill="#2C55E5"
        />
        <circle
          id="b2b285b5-c1c3-4b12-9710-2898c7239781"
          data-name="Ellipse 3"
          cx="19.30501"
          cy="13.281"
          r="4.815"
          fill="#fff"
        />
        <circle
          id="a5a428bb-42a2-4f57-9e6c-9979c01a2490"
          data-name="Ellipse 4"
          cx="37.58001"
          cy="13.281"
          r="4.815"
          fill="#fff"
        />
        <circle
          id="a9929a25-14ce-4464-bac9-4165f1e3fae6"
          data-name="Ellipse 5"
          cx="55.85501"
          cy="13.281"
          r="4.815"
          fill="#fff"
        />
        <path
          id="b4a2d72b-abc3-4d2f-a2b8-a2aff6897b26-1370"
          data-name="Path 37"
          d="M297.74287,192.20533l-38.133,37.657,38.133,37.656,8.58-8.58-28.835-28.839,29.076-29.076Z"
          transform="translate(-177.13785 -97.98434)"
          fill="#2C55E5"
        />
        <path
          id="b5120d89-6cbe-4bfa-9a1b-cf9b07deff91-1371"
          data-name="Path 38"
          d="M328.98787,192.20533l38.132,37.657-38.132,37.656-8.58-8.58,28.837-28.838-29.078-29.077Z"
          transform="translate(-177.13785 -97.98434)"
          fill="#2C55E5"
        />
        <path
          id="a31271bd-8e2f-469b-8cee-8b6db3f92f99-1372"
          data-name="Path 65"
          d="M452.33185,201.65533c-3.119,0-5.647,1.794-5.647,4.006s2.528,4.006,5.647,4.006h266.214c3.119,0,5.647-1.794,5.647-4.006s-2.528-4.006-5.647-4.006Z"
          transform="translate(-177.13785 -97.98434)"
          fill="#e6e6e6"
        />
        <path
          id="bf577952-0fd5-43e0-be6b-ea1966b51a93-1373"
          data-name="Path 78"
          d="M715.89888,421.13433h-447.838c-4.578,0-8.288-2.643-8.293-5.9v-79.042c.005-3.257,3.715-5.9,8.293-5.9h447.838c4.578,0,8.288,2.643,8.293,5.9v79.041C724.18788,418.49035,720.47688,421.13034,715.89888,421.13433Zm-447.838-88.484c-2.747,0-4.973,1.586-4.976,3.54v79.041c0,1.954,2.229,3.538,4.976,3.54h447.838c2.747,0,4.973-1.586,4.976-3.54v-79.039c0-1.954-2.229-3.538-4.976-3.54Z"
          transform="translate(-177.13785 -97.98434)"
          fill="#e6e6e6"
        />
        <circle
          id="f7f4957b-eaa8-456b-bf02-bacf7de3ef80"
          data-name="Ellipse 13"
          cx="137.04001"
          cy="277.695"
          r="20.036"
          fill="#e6e6e6"
        />
        <path
          id="fb0f055d-da6e-47f2-bb6d-7ff26d7b746a-1374"
          data-name="Path 79"
          d="M370.68788,359.65533a4.006,4.006,0,0,0-.01037,8.012H559.54884a4.006,4.006,0,0,0,0-8.012Z"
          transform="translate(-177.13785 -97.98434)"
          fill="#2C55E5"
        />
        <path
          id="bfcde504-8c45-4d21-843b-87b1f7e22ce0-1375"
          data-name="Path 80"
          d="M370.68788,383.69235a4.006,4.006,0,0,0-.01037,8.012h81.27636a4.006,4.006,0,0,0,.01038-8.012H370.68788Z"
          transform="translate(-177.13785 -97.98434)"
          fill="#2C55E5"
        />
        <path
          id="a66699ea-75f1-4575-b6d5-52b0b1f8e30c-1376"
          data-name="Path 81"
          d="M450.38788,225.65533a4.019,4.019,0,0,0,0,8.012h174.47a4.019,4.019,0,0,0,0-8.012Z"
          transform="translate(-177.13785 -97.98434)"
          fill="#e6e6e6"
        />
        <path
          id="bbc4ca7b-25d4-4c7e-b3d4-0411f69bd48f-1377"
          data-name="Path 82"
          d="M451.53583,249.65533c-2.679,0-4.851,1.794-4.851,4.006s2.172,4.006,4.851,4.006h228.7c2.679,0,4.851-1.794,4.851-4.006s-2.172-4.006-4.851-4.006Z"
          transform="translate(-177.13785 -97.98434)"
          fill="#e6e6e6"
        />
      </g>
    </svg>
  );
};

export default FeelingProud;